<!--suppress ALL -->
<template>
  <div class="s-personal">
    <!--<img school-class-manage="header-pic" :src="avatar" alt="">-->
    <el-dropdown trigger="click">
      <span class="el-dropdown-link">
        <span class="nameBox">
          <span>
            你好，{{realName}}
          </span>
       </span>
        <i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      
      <el-dropdown-menu slot="dropdown">
        <router-link to='/changePerInfo'>
          <el-dropdown-item>编辑资料</el-dropdown-item>
        </router-link>
        <router-link to="/changePassword">
          <el-dropdown-item>修改密码</el-dropdown-item>
        </router-link>
        <div @click="logout">
          <el-dropdown-item>退出登录</el-dropdown-item>
        </div>
      </el-dropdown-menu>
    </el-dropdown>
    <span style="color: #fff;user-select:none;padding:0 5px 0 5px;"> | </span>
    <!-- <i class="iconfont  icon-el-icon-home" @click="goIndex"></i> -->
    <i style="cursor:pointer;font-size:16px;font-style:normal;" @click="goIndex">返回首页</i>
    <span style="padding:0 5px 0 5px;user-select:none;color: #fff;"> | </span>
    <!-- <i class="iconfont  icon-el-icon-start" @click="logout"></i> -->
    <i style="font-style:normal;cursor:pointer;font-size:16px;" @click="logout">退出登录</i>
  </div>
</template>

<script>
  import {baseUrl, ERR_OK} from 'common/api/api'

  export default {
    data() {
      return {
        rootUrl: baseUrl,
        getUserInfoUrl: '/api/common/user/info',
        avatar: 'static/images/header-default.png',
        realName: '',
        role: '',
        userId: '',
        phone: '',
        roleIds: ''
      }
    },
    created: function () {
      this.getUserInfo()
    },
    methods: {
      /* 获取用户信息 */
      getUserInfo() {
        this.$http({
          method: 'post',
          url: this.rootUrl + this.getUserInfoUrl
        }).then((res) => {
          // console.log(res)
          if (res.body.code === ERR_OK) {
            let result = res.body.data.user
            // console.log(result)
            this.avatar = result.imageUrl
            this.realName = result.realName
            this.role = result.roleNames
            this.userId = result.id
            this.phone = result.phone
            this.roleIds = result.roleIds
            window.localStorage.setItem('userId', result.id)
          }
        }, (res) => {
          // console.log('er')
        })
      },
      goIndex() {
        this.getUserInfo()
        this.$router.push({path: '/index'})
      },
      logout() {
        // console.log('logout')
        window.localStorage.removeItem('token')
        this.$router.push({path: '/'})
      }
    },
    watch: {
      $route(to, from) {
        if (to.fullPath === '/index' && from.fullPath === '/changePerInfo') {
          this.getUserInfo()
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "~common/scss/variable.scss";

  .s-personal {
    // background: #df6005;
    float: right;
    .el-dropdown-link {
      cursor: pointer;
      color: #fff;
    }
    .el-dropdown-menu {
      left: 0;
    }
    .iconfont {
      margin-left: 20px;
      font-size: 18px;
      position: relative;
      top: 2px;
      cursor: pointer;
    }
  }
  .nameBox {
    font-size: 16px;
    display: inline-block;
    /*vertical-align: middle;*/
    .role {
      font-size: $font-size-small-s;
    }
  }


</style>





// WEBPACK FOOTER //
// src/components/personal/personal.vue